import { render, staticRenderFns } from "./RedeemManagementScreen.vue?vue&type=template&id=7067d078&scoped=true&"
import script from "./RedeemManagementScreen.vue?vue&type=script&lang=js&"
export * from "./RedeemManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067d078",
  null
  
)

export default component.exports